import type { Core } from '@strapi/types';
import { API } from '@/modules/api-service/api-service';

import type { IEmailHelp, IEmailHelpResponse } from '../types/app-config.type';

export const getAppConfig = async () => {
	const { data: response } =
		await API().get<Core.Helpers.Controllers.GetResponseBody<'api::app-config.app-config', 'getAppConfig'>>('/app-config');

	return response;
};

export const sendHelpMailApi = async (helpInformation: IEmailHelp): Promise<IEmailHelpResponse> => {
	const response = await API('https://api.docweb.econfigure.abb.com/api/').post<IEmailHelpResponse, IEmailHelp>(
		'Users/SendHelpMail/',
		helpInformation,
	);

	return response.data;
};
